import { render, staticRenderFns } from "./CreditCheckDetails.vue?vue&type=template&id=b831caee&scoped=true"
import script from "./CreditCheckDetails.vue?vue&type=script&lang=js"
export * from "./CreditCheckDetails.vue?vue&type=script&lang=js"
import style0 from "./CreditCheckDetails.vue?vue&type=style&index=0&id=b831caee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b831caee",
  null
  
)

export default component.exports